import { useLocation } from '@tanstack/react-router'
import { useMemo } from 'react'

import { useSelectedOrgAndSiteInterface } from './orgSiteInterface'
import {
  type ActiveOrgSite,
  isInternalRoute,
  resolveActiveOrgSite,
} from './resolveActiveOrgSite'
import { useOrgSiteEntries } from './useOrgSiteEntries'
import { useRouteOrgSiteParams } from './useRouteOrgSiteParams'

export interface UseActiveOrgSiteResult extends ActiveOrgSite {
  /** False until the org and site list has loaded, so default-site scope is not guessed. */
  isResolved: boolean
}

/** The org and site the navbar shows, resolved by the same rule. Does not need RolodexProvider. */
export function useActiveOrgSite(): UseActiveOrgSiteResult {
  const { pathname } = useLocation()
  const { getOrganizationId, getSiteId } = useSelectedOrgAndSiteInterface()
  const { organizations, sites, isLoaded, error } = useOrgSiteEntries()
  const route = useRouteOrgSiteParams()

  const urlOrganizationId = getOrganizationId()
  const urlSiteId = getSiteId()

  const active = useMemo(
    () =>
      resolveActiveOrgSite({
        pathname,
        route,
        urlOrganizationId,
        urlSiteId,
        organizations,
        sites,
      }),
    [pathname, route, urlOrganizationId, urlSiteId, organizations, sites]
  )

  return {
    ...active,
    isResolved: isInternalRoute(pathname) || isLoaded || Boolean(error),
  }
}
